import React, { useState, useEffect } from 'react';
import { useDebounce } from 'use-debounce';
import { connect, useDispatch } from "react-redux";
import { authActions, visitaAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Row, Col, Card, CardBody, UncontrolledTooltip, Input, Badge, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import NavBar from '../_components/navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faPen, faTrash, faFilePdf, faFileExcel, faSearch, faTimes, faChevronLeft, faChevronRight, faClipboardList, faBuilding, faUser, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import Moment from 'react-moment';
import 'moment-timezone';

const Visita = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // State
    const [id, setId] = useState(-1);
    const [edit, setEdit] = useState("");
    const [term, setTerm] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(12);
    const [valueDebounce] = useDebounce(term, 1000);

    // Delete validation state
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    useEffect(() => {
        // Keeping the original pagination logic but using 12 items per page for grid
        dispatch(visitaAction.getVisita(true, page, limit, valueDebounce));
    }, [page, limit, valueDebounce]);

    const handleChange = event => {
        setTerm(event.target.value);
        setPage(1); // Reset to first page on search
    };

    const confirmDelete = (event, id) => {
        event.preventDefault();
        setItemToDelete(id);
        setDeleteModalOpen(true);
    };

    const handleDelete = () => {
        if (itemToDelete) {
            dispatch(visitaAction.deleteVisitaById(itemToDelete));
            setDeleteModalOpen(false);
            setItemToDelete(null);
        }
    };

    const { visita, totalItems } = props.visita;
    // Calculate total pages based on totalItems from backend
    const totalPages = Math.ceil(totalItems / limit);

    const getRelatorioLabel = (tipo) => {
        switch (tipo) {
            case 'V ': return 'VISITA';
            case 'A ':
            case 'AN':
            case 'AL': return 'ANIMAIS';
            case 'G ': return 'GENEALOGIA';
            case 'EX': return 'ANIMAIS CADASTRADOS';
            case 'RV': return 'REPRODUÇÃO VACAS';
            case 'RN': return 'REPRODUÇÃO NOVILHAS';
            case 'BS': return 'BST';
            case 'PL': return 'PRODUÇÃO LOTES';
            case 'EM': return 'EMPRESAS';
            case 'VT': return 'VISITA TÉCNICA';
            case 'VV': return 'VETERINÁRIO';
            default: return '';
        }
    };

    const getRelatorioColor = (tipo) => {
        // Returns color based on report type for Badge
        return 'primary'; // Default color, can be customized
    };

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingBottom: '60px' }}>
            <NavBar {...props} />
            <Container className="py-5">
                {/* Header Section */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-5">
                    <div className="mb-3 mb-md-0">
                        <h2 className="font-weight-bold text-dark mb-1">Visitas</h2>
                        <p className="text-muted mb-0">Acompanhe relatórios e visitas técnicas</p>
                    </div>

                    <div className="d-flex align-items-center flex-column flex-sm-row">
                        <div className="position-relative mr-0 mr-sm-3 mb-3 mb-sm-0 w-100" style={{ maxWidth: '300px' }}>
                            <Input
                                id="term"
                                placeholder="Buscar por fazenda, empresa..."
                                value={term}
                                onChange={handleChange}
                                style={{
                                    paddingLeft: '40px',
                                    borderRadius: '50px',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                                    height: '45px'
                                }}
                            />
                            <FontAwesomeIcon
                                icon={faSearch}
                                className="text-muted position-absolute"
                                style={{ left: '15px', top: '50%', transform: 'translateY(-50%)' }}
                            />
                            {term && (
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="text-muted position-absolute cursor-pointer"
                                    onClick={() => { setTerm(''); setPage(1); }}
                                    style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                                />
                            )}
                        </div>

                        <Button
                            id="btnNovo"
                            color="primary"
                            className="btn-rounded px-4 shadow-sm border-0 d-flex align-items-center"
                            style={{ borderRadius: '50px', fontWeight: '600', height: '45px', backgroundColor: 'var(--primary-color)' }}
                            onClick={() => navigate("/visita")}
                        >
                            <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                            <span className="text-nowrap">Nova Visita</span>
                        </Button>
                        <UncontrolledTooltip placement="bottom" target="btnNovo">
                            Adicionar uma nova Visita
                        </UncontrolledTooltip>
                    </div>
                </div>

                {/* Grid Section */}
                {visita && visita.length > 0 ? (
                    <>
                        <Row>
                            {visita.map((item) => (
                                <Col xs={12} md={6} lg={4} className="mb-4" key={item.id}>
                                    <Card className="h-100 border-0 shadow-sm hover-cards" style={{ borderRadius: '16px', overflow: 'hidden', transition: 'all 0.3s ease' }}>
                                        <CardBody className="p-4 d-flex flex-column">

                                            <div className="d-flex align-items-center mb-4">
                                                <div className="d-flex justify-content-center align-items-center bg-light text-success rounded-circle mr-3"
                                                    style={{ width: '50px', height: '50px', backgroundColor: 'var(--primary-light)' }}>
                                                    <FontAwesomeIcon icon={faClipboardList} size="lg" />
                                                </div>
                                                <div style={{ overflow: 'hidden' }}>
                                                    <h5 className="mb-1 font-weight-bold text-dark text-truncate" title={item.nome_fazenda}>
                                                        {item.nome_fazenda.toUpperCase()}
                                                    </h5>
                                                    <Badge color={getRelatorioColor(item.tipo_relatorio)} className="px-2 py-1">
                                                        {getRelatorioLabel(item.tipo_relatorio)}
                                                    </Badge>
                                                </div>
                                            </div>

                                            <div className="mb-4 flex-grow-1">
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                                                    </div>
                                                    <span className="font-weight-bold">
                                                        <Moment format="DD/MM/YYYY">{item.data}</Moment>
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faBuilding} className="text-muted" />
                                                    </div>
                                                    <span className="text-truncate" title={item.nome_empresa}>
                                                        {item.nome_empresa.toUpperCase()}
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faUser} className="text-muted" />
                                                    </div>
                                                    <span className="text-truncate" title={item.nome_usuario}>
                                                        {item.nome_usuario.toUpperCase()}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="mt-auto pt-3 border-top d-flex justify-content-between align-items-center">
                                                <div className="d-flex">
                                                    <Button
                                                        color="secondary"
                                                        className="d-flex align-items-center justify-content-center mr-2 rounded-circle shadow-sm border-0"
                                                        style={{ width: '38px', height: '38px', padding: 0 }}
                                                        component='a' href={item.arquivo} target="_blank"
                                                        id={`btnPdf${item.id}`}
                                                        title="PDF"
                                                    >
                                                        <FontAwesomeIcon icon={faFilePdf} size="sm" />
                                                    </Button>
                                                    <UncontrolledTooltip placement="bottom" target={`btnPdf${item.id}`}>
                                                        Abrir PDF
                                                    </UncontrolledTooltip>

                                                    {item.excel && item.excel !== "" && (
                                                        <>
                                                            <Button
                                                                color="success"
                                                                className="d-flex align-items-center justify-content-center mr-2 rounded-circle shadow-sm border-0"
                                                                style={{ width: '38px', height: '38px', padding: 0 }}
                                                                component='a' href={item.excel} target="_blank"
                                                                id={`btnExcel${item.id}`}
                                                                title="Excel"
                                                            >
                                                                <FontAwesomeIcon icon={faFileExcel} size="sm" />
                                                            </Button>
                                                            <UncontrolledTooltip placement="bottom" target={`btnExcel${item.id}`}>
                                                                Abrir Excel
                                                            </UncontrolledTooltip>
                                                        </>
                                                    )}
                                                </div>

                                                <div className="d-flex">
                                                    <Button
                                                        color="primary"
                                                        className="d-flex align-items-center justify-content-center mr-2 rounded-circle shadow-sm border-0"
                                                        style={{ width: '38px', height: '38px', padding: 0, backgroundColor: 'var(--primary-color)' }}
                                                        component='a'
                                                        href={`/visita/${item.id}`}
                                                        title="Editar"
                                                    >
                                                        <FontAwesomeIcon icon={faPen} size="sm" />
                                                    </Button>
                                                    <Button
                                                        color="danger"
                                                        className="d-flex align-items-center justify-content-center rounded-circle shadow-sm border-0"
                                                        style={{ width: '38px', height: '38px', padding: 0, backgroundColor: '#e03131' }}
                                                        onClick={(e) => confirmDelete(e, item.id)}
                                                        title="Excluir"
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} size="sm" />
                                                    </Button>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                        {/* Pagination */}
                        {totalPages > 1 && (
                            <Row>
                                <Col className="d-flex justify-content-center mt-4 mb-4">
                                    <div className="d-flex align-items-center bg-white shadow-sm rounded-pill px-2 py-1">
                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === 1 ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </Button>

                                        <span className="mx-3 text-muted font-weight-bold small">
                                            Página {page} de {totalPages}
                                        </span>

                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === totalPages ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page >= totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </>
                ) : (
                    <Row>
                        <Col className="text-center py-5">
                            <div className="mb-4">
                                <div className="bg-white rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center p-4">
                                    <FontAwesomeIcon icon={faClipboardList} size="3x" className="text-muted opacity-50" />
                                </div>
                            </div>
                            <h4 className="text-secondary font-weight-bold">Nenhum registro encontrado</h4>
                            <p className="text-muted">Não encontramos visitas com os filtros atuais.</p>
                            {term && (
                                <Button color="primary" outline onClick={() => { setTerm(''); setPage(1); }} className="mt-2 rounded-pill px-4">
                                    Limpar Filtros
                                </Button>
                            )}
                        </Col>
                    </Row>
                )}
            </Container>

            {/* Delete Confirmation Modal */}
            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)} centered>
                <ModalHeader toggle={() => setDeleteModalOpen(false)} className="border-0 pb-0"></ModalHeader>
                <ModalBody className="text-center pb-4">
                    <div className="mb-3 text-danger bg-light-danger d-inline-block rounded-circle p-3" style={{ backgroundColor: '#ffebee' }}>
                        <FontAwesomeIcon icon={faTrash} size="2x" />
                    </div>
                    <h4 className="mb-2 font-weight-bold">Excluir Visita</h4>
                    <p className="text-muted mb-4">Tem certeza que deseja excluir esta visita? Esta ação não pode ser desfeita.</p>
                </ModalBody>
                <ModalFooter className="border-0 pt-0 justify-content-center pb-4">
                    <Button color="light" onClick={() => setDeleteModalOpen(false)} className="mr-2 rounded-pill px-4 font-weight-bold">Cancelar</Button>
                    <Button color="danger" onClick={handleDelete} className="rounded-pill px-4 font-weight-bold shadow-sm">Confirmar Exclusão</Button>
                </ModalFooter>
            </Modal>

            

            <style>{`
                .hover-cards:hover {
                    box-shadow: 0 10px 25px rgba(0,0,0,0.08) !important;
                    transform: translateY(-4px);
                }
            `}</style>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        visita: state.visita,
        fazenda: state.fazenda,
        empresa: state.empresa
    };
};

const connectedVisitaPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(Visita));
export { connectedVisitaPage as Visita };